import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="notice-dismissal"
export default class extends Controller {
  // ターゲットの定義
  static targets = ["notice"];

  // 値の定義
  static values = {
    key: { type: String },
  };

  // ターゲットと値の型定義
  declare readonly noticeTarget: HTMLElement;
  declare readonly keyValue: string;

  connect(): void {
    // ページロード時にlocalStorageをチェック
    if (localStorage.getItem(this.keyValue) !== "dismissed") {
      this.noticeTarget.style.display = "";
    }
  }

  dismiss(): void {
    // クリック時にlocalStorageに保存
    localStorage.setItem(this.keyValue, "dismissed");

    // 要素を非表示
    this.noticeTarget.style.display = "none";
  }
}
